/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import GeneralMessageModal from './GeneralMessageModal.js';
import requestConnector from './requestConnector.js';
import reduxConnector from './reduxConnector.js';
export default reduxConnector(requestConnector(GeneralMessageModal));
